import React from 'react';
import { Page, Link, Navbar, Block } from 'framework7-react';

import { ColumnView } from 'Containers';
import { NavigationService } from 'Services';

import './style.scss';

const NotFound = () => (
  <Page id={'not-found-page'}>
    <Navbar className="text-white" title="Not found" backLink="Back" />
    <ColumnView paddingHorizontal={20}>
      <Block>
        <div className="screen-title text-white">Sorry</div>
        <div className="screen-subtitle text-white">Requested content not found.</div>
      </Block>
      <Link className="pt-24" onClick={NavigationService.goBack}>
        Go back
      </Link>
    </ColumnView>
  </Page>
);

export default NotFound;
